module.exports = __webpack_public_path__ + "img/splash.f1e7d393.gif";